import React, { useEffect } from "react";
import useRouterContext from "../../hooks/useRouterInit";
import RouterContext from "../../libs/router/Router";
function Router(props) {
    const context = useRouterContext();
    useEffect(() => {
        const popstateChange = () => {
            context.setState({ ...context.state, path: window.location.pathname });
        };
        window.addEventListener("popstate", popstateChange);
        return () => {
            window.removeEventListener("popstate", popstateChange);
        };
    });
    return (React.createElement(RouterContext.Provider, { value: context }, props.children));
}
export default Router;
